/*! bxs-vue-ui v4.0.1 */
import '../utils/es.array.join.js';
import { c as create, n as normalizeComponent } from '../utils/normalize-component.js';
import '../utils/index.js';
import 'vue';
import '../utils/concat.js';
import { E as Emitter } from '../utils/emitter.js';

//
var script = create({
  name: 'radio-group',
  mixins: [Emitter],
  props: {
    value: null,
    disabled: {
      type: Boolean,
      default: false
    },
    labelDisable: {
      type: Boolean,
      default: false
    },
    selectColor: {
      type: String,
      default: 'primary'
    }
  },
  watch: {
    value: function value(_value) {
      this.$emit('change', _value);
      this.dispatch('bxs-form-item', 'form.item.reset');
    }
  }
});

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm._t("default")], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

export default __vue_component__;
